import { createSlice } from "@reduxjs/toolkit";

interface CartItemRequestState {
  rowsPerPage: number;
  startDate: string; // YYYY-MM-DD
}

const today = new Date().toISOString().slice(0, 10);

const initialState: CartItemRequestState = {
  rowsPerPage: 10,
  startDate: today,
};

const cartItemRequestSlice = createSlice({
  name: "cartItemRequest",
  initialState,
  reducers: {
    setRowsPerPage(state, action) {
      state.rowsPerPage = action.payload;
    },
    clearRowsPerPage(state) {
      state.rowsPerPage = 10;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    clearStartDate(state) {
      state.startDate = today;
    },
  },
});

export const { setRowsPerPage, clearRowsPerPage, setStartDate, clearStartDate } = cartItemRequestSlice.actions;

export default cartItemRequestSlice.reducer;
